import React from "react";
import { Link } from "gatsby";
import { Wrapper } from "./Navigation.styles"
import {GlobalDispatchContext } from "../../../src/context/GlobalContextProvider"

const Navigation = ({ menu }) => {

    const dispatch = React.useContext(GlobalDispatchContext)
  
    const clearSearchParams = ()=> {
        dispatch({type: 'SEARCH_PARAMS', payload: null})
    }

    return(
        <Wrapper>
            <ul>
                {menu.map(mainItem => 
                    !mainItem.parentId
                        ? (
                            <li key={mainItem.id}>
                                {
                                    mainItem.target !== null
                                        ? (
                                            <a href={mainItem.url} target={mainItem.target} className={mainItem.cssClasses.join(' ')}>
                                                {mainItem.label}
                                                {mainItem.childItems.nodes.length !== 0 && <div className="subitems-arrow">&#8964;</div>}
                                            </a>
                                          )

                                        : (
                                            <Link to={mainItem.url} activeClassName="active" className={mainItem.cssClasses.join(' ')}>
                                                <span className="text">{mainItem.label}</span>
                                                {mainItem.childItems.nodes.length !== 0 && <div className="subitems-arrow">&#8964;</div>}
                                            </Link>
                                          )
                                }

                                {mainItem.childItems.nodes.length !== 0 ? (
                                    <ul>
                                        {mainItem.childItems.nodes.map(childItem => (
                                            <li key={childItem.id}>
                                                <Link onClick={clearSearchParams} to={childItem.url} activeClassName="active">
                                                    <span className="text">{childItem.label}</span>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                ) : null }
                            </li>
                        )
                        : null
                    )
                }
            </ul>
        </Wrapper>
    )
}

export default Navigation;